export default __webpack_public_path__ + "static/media/logo.5d2ff6b3.png";